import { xhrRequest } from '../../shared/helpers';

export default class extends Controller {
  static targets = ['expandedContentContainer', 'closeLink'];

  connect() {
    this.closeIfOutsideClick = this.closeIfOutsideClick.bind(this);
    if (this.hasExpandedContentContainerTarget) {
      this.expandedContentContainerTarget.dataset.action =
        `mouseenter->${this.controller}#showCloseLink mouseleave->${this.controller}#hideCloseLink`;
    }
  }

  openExpandedContent(event, url=this.url) {
    if (!this.hasExpandedContent) {
      this.expandedContent = App.spinner();
      this.getExpandedContent(url);
    }
    this.addCloseLink();
    this.element.classList.remove(this.dragClass);
    this.isExpanded = true;
    document.addEventListener('click', this.closeIfOutsideClick);
  }

  closeExpandedContent(event) {
    event && event.stopImmediatePropagation();
    this.element.classList.add(this.dragClass);
    this.isExpanded = false;
    document.removeEventListener('click', this.closeIfOutsideClick);
  }

  showCloseLink() {
    this.hasCloseLinkTarget && (this.closeLinkTarget.style.display = 'block');
  }

  hideCloseLink() {
    this.hasCloseLinkTarget && (this.closeLinkTarget.style.display = 'none');
  }

  //
  // INTERNAL USE
  //

  addCloseLink() {
    if (!this.hasCloseLink) {
      this.expandedContentContainerTarget.prepend(this.closeLink);
    }
  }

  closeIfOutsideClick(event) {
    event.target !== this.element && !this.element.contains(event.target) && this.closeExpandedContent();
  }

  getExpandedContent(url=this.url) {
    url && xhrRequest(url, 'get').then(({ data }) => { this.expandedContent = data; });
  }

  //
  // GETTERS AND SETTERS
  //

  get url() {
    const url = this.data.get('url');
    return url ? App.Helpers.addParamsToURL(url, {
      return_to:        document.location.href,
      is_multi_account: this.isMultiAccount ? '1' : null
    }) : null;
  }

  get isExpanded() {
    return this.hasExpandedContentContainerTarget && this.expandedContentContainerTarget.classList.contains('expanded');
  }

  set isExpanded(expand) {
    this.hasExpandedContentContainerTarget && this.expandedContentContainerTarget.classList[expand ? 'add' : 'remove']('expanded');
  }

  get hasExpandedContent() {
    return this.hasExpandedContentContainerTarget && !!this.expandedContentContainerTarget.innerHTML;
  }

  get expandedContent() {
    return this.hasExpandedContentContainerTarget && this.expandedContentContainerTarget.innerHTML;
  }

  set expandedContent(html) {
    if (this.hasExpandedContentContainerTarget) {
      this.expandedContentContainerTarget.innerHTML = html;
      App.addHandlers(this.expandedContentContainerTarget);
      if (this.expandedContentContainerTarget.innerHTML) this.expandedContentContainerTarget.prepend(this.closeLink);
    }
  }

  get isMultiAccount() {
    const multiAccountField = document.querySelector('[data-status=multi-account]');
    return multiAccountField && multiAccountField.value == '1';
  }

  get dragClass() {
    return this.data.get('drag-class');
  }

  get closeLink() {
    const closeDiv = document.createElement('div');
    closeDiv.classList.add('close-expanded');
    closeDiv.dataset.target = `${this.controller}.closeLink`;
    closeDiv.innerHTML = `
      <a href="#!" data-action="${this.controller}#closeExpandedContent">
        <i class="fas fa-times"></i>
      </a>`;
    return closeDiv;
  }

  get hasCloseLink() {
    return !!this.expandedContentContainerTarget.querySelector('.close-expanded');
  }

  get controller() {
    return this.identifier;
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/expandable-activity-controller.js